import React from 'react';
import { useCms } from '../cms/CmsContext';
import { getCmsImagePath } from '../cms/cmsData';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import './EventMap.css';
import { getArabicTranslation } from '../utils/arabicTranslations';

const EventMap = () => {
  const { content } = useCms();
  const cms = content?.eventMapPage || {};

  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          <h1 className="card-title">{cms.title} <span className="arabic-text on-white">{getArabicTranslation('Event Map')}</span></h1>
          <div className="card-content">
            <p className="card-description">
              {cms.description}
            </p>

            <div className="event-map-container">
              <img
                loading="lazy"
                src="/map.png"
                alt="OC MENA Festival event map"
                className="event-map-image"
              />
            </div>
          </div>
        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath('lanterns', '/lanterns.webp')} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <SponsorsSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default EventMap;
